<template>
	<div>
		<div class="title-container">
			<div class="title"><span class="fad fa-token"></span>{{ tokens.length }} API Token{{ tokens.length !== 1 ? 's' : '' }}</div>
			<div class="buttons-container buttons">
				<router-link :to="{ name: 'tokens-create-page', params: $route.params }" class="button"><div class="hover-title">Add Token</div><span class="fa fa-plus"></span></router-link>
			</div>
		</div>

		<div class="table list">
			<div v-if="tokens.length > 0" class="row">
				<div class="cell"><a href @click.prevent class="point-down">Name</a></div>
				<div class="cell"><a href @click.prevent class="point-up">Last Used At</a></div>
				<div class="cell"></div>
			</div>
			<div v-for="token in tokens" :key="`account-${ currentAccount.id }-${ token.id }`"  class="row">
				<div class="cell">{{ token.name }}</div>

				<div v-if="token.last_used_at" class="cell"><date :date="token.last_used_at" /></div>
				<div v-if="!token.last_used_at" class="cell">Never Used</div>

				<div class="cell align-right">
					<div class="buttons">
						<delete-button @deleted="(done) => deleteRow(token, done)"></delete-button>
					</div>
				</div>
			</div>

			<nothing-here v-if="tokens.length === 0"></nothing-here>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import DeleteButton from '@/views/components/DeleteButton';

export default {

	name: 'TokensOverviewPage',

	async asyncData({ app, route, store }) {
		const { data } = await app.$api.get(`/tokens`);

		return {
			tokens: data,
		};
	},

	data() {
		return {
			tokens: [],
		};
	},

	computed: mapGetters(['currentAccount']),

	methods: {

		async deleteRow(token, done) {
			await this.$api.post(`/tokens/${ token.id }/delete`).then(() => {
				this.$store.dispatch('addToast', `Token Deleted`);
				this.tokens = this.tokens.filter(({ id }) => id !== token.id);
				done();
			});
		}

	},

	components: {
		DeleteButton,
	},

};

</script>
